import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import FolderIcon from '../../../common/FolderIcon';
import PDFIcon from '../../../common/PDFIcon';
import FolderIconOpen from '../../../common/FolderIconOpen';

class StudiesTable extends Component {
  state = {
    activeFolder: [],
  }

  UNSAFE_componentWillMount() {
    if (this.props.data.folders.length > 0) {
      this.setState({ activeFolder: [this.props.data.folders[0].id] });
    }
  }

  componentDidMount() {
    this.props.checkForScroll();
  }

  onFolderToggle = folderId => {
    // let activeFolder = [...this.state.activeFolder];
    // if (activeFolder.includes(folderId)) {
    //   activeFolder = activeFolder.filter(k => k !== folderId);
    // } else {
    //   activeFolder.push(folderId);
    // }
    this.setState({ activeFolder: [folderId] }, () => {
      if (this.state.activeFolder.includes(folderId)) {
        // const currentOffset = $(`#custom-mri-table--row--folder_${folderId}`).offset().top;
        // const containerOffset = $('.custom-mri-table--body').offset().top;
        // const containerScrollTop = $('.custom-mri-table--body').scrollTop();
        // if (currentOffset !== containerOffset) {
        //   const offset = currentOffset + containerScrollTop;
        //   $('.custom-mri-table--body').animate({
        //     scrollTop: offset,
        //   }, 200);
        // }
      }
      this.props.checkForScroll();
    });
  }

  extractContent = s => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent.trim() || span.innerText.trim();
  };

  userGuideRowList = files => {
    const renderList = _.map(files, item => {
      return (
        <div className="custom-mri-table--row" key={item.id} id={item.id}>
          <div className="custom-mri-table--col user-guide-col-name">
            <a className="user-guide-name" title={this.extractContent(item.title.name)} href={item.sourceUrl} target="_blank" rel="noopener noreferrer">
              <PDFIcon size="25px" />
              <div className="user-guide-text" dangerouslySetInnerHTML={{ __html: item.title.name }} />
            </a>
          </div>
          <div className="custom-mri-table--col user-guide-col-uploaded">
            <span className="user-guide-text">{item.modified ? moment(item.modified).format('MMM DD, YYYY') : ' '}</span>
          </div>
          <div className="custom-mri-table--col user-guide-col-actions">
            <div className="user-guide-actions">
              <a className="user-guide-actions--download" title="Download File" href={item.sourceUrl} target="_blank" rel="noopener noreferrer" download>
                <i className="user-guide--download-icon" />
              </a>
              <a className="user-guide-actions--preview" title="Preview File" href={item.sourceUrl} target="_blank" rel="noopener noreferrer">
                <span className="preview_icon" />
              </a>
            </div>
          </div>
        </div>
      );
    });
    return renderList;
  };

  renderFolderRows = () => {
    const { data } = this.props;
    const { activeFolder } = this.state;
    let items = [];
    if (data.folders.length > 0) {
      items = data.folders.map((folder, i) => {
        let folderFiles = '';
        let folderIcon = <FolderIcon />;
        let buttonClass = 'custom-mri-table--row--folder--toggle';
        let totalFiles = <span className="total-files">{folder.files.length}</span>;
        if (activeFolder.includes(folder.id)) {
          folderFiles = (
            <div className="files">
              {this.userGuideRowList(folder.files)}
            </div>
          );
          folderIcon = <FolderIconOpen fill="#4e0e28" />;
          buttonClass = 'custom-mri-table--row--folder--toggle custom-mri-table--row--folder--toggle-active';
          totalFiles = '';
        }

        return (
          <div key={i} id={`custom-mri-table--row--folder_${folder.id}`} className="custom-mri-table--row--folder">
            <button onClick={() => this.onFolderToggle(folder.id)} className={buttonClass}>
              <i className="icon-folder">
                {folderIcon}
              </i>
              <span className="folder-desc">
                <span className="folder-name">{folder.title.name}</span>
                {totalFiles}
              </span>
            </button>
            <div>
              {folderFiles}
            </div>
          </div>
        );
      });
    }

    return items;
  };

  renderTableRows = () => {
    const { data } = this.props;
    const fileRows = this.userGuideRowList(data.files);
    const folderRows = this.renderFolderRows();
    return [...fileRows, ...folderRows];
  };

  render() {
    const { data, onSort, sortColumnName, sortDirection } = this.props;
    if (_.isEmpty(data.files) && _.isEmpty(data.folders)) {
      return (
        <div className="no-record-found-message">
          There are no documents available for this study
        </div>
      );
    }
    return (
      <div className="custom-mri-table">
        <div className="custom-mri-table--head">
          <div className="custom-mri-table--row">
            <div className="custom-mri-table--col user-guide-col-name">
              <span>Name</span>
              <button
                onClick={() => onSort('Name')}
                className={sortColumnName === 'Name' ? `custom-mri-table--sort custom-mri-table--sort_${sortDirection}` : 'custom-mri-table--sort'}
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col user-guide-col-uploaded">
              <span>Uploaded</span>
              <button
                onClick={() => onSort('Uploaded')}
                className={sortColumnName === 'Uploaded' ? `custom-mri-table--sort custom-mri-table--sort_${sortDirection}` : 'custom-mri-table--sort'}
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col user-guide-col-actions">
              <span>Actions</span>
            </div>
          </div>
        </div>
        <div className="custom-mri-table--body">
          {this.renderTableRows()}
        </div>
      </div>
    );
  }
}

StudiesTable.propTypes = {
  data: PropTypes.instanceOf(Object),
  onSort: PropTypes.func,
  checkForScroll: PropTypes.func,
  sortColumnName: PropTypes.string,
  sortDirection: PropTypes.string,
};


export default StudiesTable;
